import { UserService } from './user.service';
import { Injectable, assertPlatform } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

import { Storage } from '@ionic/storage';
import { Platform, ToastController } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';

import { DeviceService } from './device.service'
import { environment, client } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {

    authState = new BehaviorSubject(null);

    constructor(
        private router: Router,
        private http: HttpClient,
        private storage: Storage,
        private platform: Platform,
        public toastController: ToastController,
        private userService: UserService,
        public deviceService: DeviceService) {

        this.platform.ready().then(async () => {
            this.ifLoggedIn();
        });
    }

    ifLoggedIn() {
        this.storage.get('USER_INFO').then(response => {
            if (response) {
                this.authState.next(true);
            } else {
                // Sin token en storage: verificar si hay sesión activa vía cookie (SSO)
                this.http.get(`${environment.apiUlr}/me`).subscribe(
                    (user: any) => {
                        // Sesión válida via cookie — poblar storage igual que login normal
                        this.storage.set('USER_INFO', user).then(() => {
                            this.storage.set('user', user).then(() => {
                                this.userService.user = user;
                                this.deviceService.isLoggedIn = true;
                                this.authState.next(true);
                            });
                        });
                    },
                    (_err) => {
                        // Sin sesión válida → flujo normal a /login
                        this.authState.next(false);
                    }
                );
            }
        });
    }

    loginEmail(credentials: any) {

        const headers = new HttpHeaders();
        headers.append('Access-Control-Allow-Origin', '*');

        const data = {
            client_secret: client.client_secret,
            client_id: client.client_id,
            username: credentials.email,
            password: credentials.password,
            grant_type: client.grant_type
        };

        return this.http.post(environment.oauthTokenUrl, data, { headers });
    }

    saveStorageLogin(user: any) {
        // tslint:disable-next-line: variable-name
        console.log('user--token: ' + JSON.stringify(user));
        /// this.deviceService.setStorage('toke', user.access_token);
        this.storage.set('USER_INFO', user).then(response => {
            if (response) {
                this.deviceService.isLoggedIn = true;
                this.authState.next(true);
                this.router.navigateByUrl('/index', { replaceUrl: true });
            }
        });

    }

    saveUserStorage(user: any) {
        this.storage.set('user', user).then(response => {
            if (response) {
                console.log('se almaceno el usuario correctamente');
                this.userService.user = user;
            }
        });
    }

    /* async getuserInfo() {
        this.userService.getUser().subscribe( response => {
            console.log(response);
            this.deviceService.setStorage('user', response);
        }, err=> {

        });
    } */

    async logout() {
        this.storage.remove('address-selected').then(() => { });
        this.storage.remove('card-selected').then(() => { });
        this.storage.remove('user').then(() => { });
        this.storage.remove('filters').then(() => { });
        this.storage.remove('filters').then(() => { });
        this.storage.set('filters', null);
        this.storage.remove('USER_INFO').then(() => {
            this.router.navigate(['login']);
            this.authState.next(false);
            this.deviceService.isLoggedIn = false;
        });
    }

    isAuthenticated() {
        return this.authState.value;
    }

    register(data: any) {
        return this.http.post(`${environment.apiUlr}/register`, data);
    }

    forgotPass(data: any) {
        return this.http.post(`${environment.apiUlr}/password/email`, data);
    }
}
